import ShelfController from '../../core/shelf.controller';
import { message } from 'antd';
import Inherit from '../../core/inherit';
import PromotersDelegate from './promoters.delegate';
import { User } from '../../data';
import { t } from '../../company/labels';

class PromotorsController extends Inherit(ShelfController, PromotersDelegate) {
    async initialize() {
        if (!this.isAuthenticated) this.navigateLogin();

        // Load the client list for the "Filtrar por cliente" dropdown (admin/gerente only —
        // client users are already scoped to their own client server-side).
        const currentUser = User.getInstance();
        if (currentUser?.userType !== 'client') {
            this.data
                .fetchClients()
                .then((clients) => {
                    const clientOptions = (clients || [])
                        .filter((c) => c?._id && c?.name)
                        .map((c) => ({ label: c.name, value: c._id }))
                        .sort((a, b) => a.label.localeCompare(b.label));
                    this.setState({ clientOptions });
                })
                .catch(() => {});
        }

        // Use the new optimized endpoint with caching
        await this.fetchPromotorsOptimized();
    }

    /**
     * Filter the promotor list by client. The backend restricts promotors to those with the
     * client's stores in their calendar and scopes the compliance % to that client's stores.
     */
    selectClient(clientId) {
        this.setState({ selectedClientId: clientId || null }, () => this.fetchPromotorsOptimized());
    }

    /**
     * Fetch promotors using the optimized endpoint with server-side caching.
     * When logged in as a client user, filters promotors to only those with
     * stores assigned from that client.
     */
    async fetchPromotorsOptimized(forceRefresh = false) {
        try {
            this.setState({ loading: true });

            const currentUser = User.getInstance();
            const isClientUser = currentUser?.userType === 'client';
            // Client users are locked to their own client; admins use the dropdown selection.
            const clientId = isClientUser ? currentUser?.client : this.state.selectedClientId || null;

            const response = await this.data.fetchPromotorsStats('all', forceRefresh, clientId);

            if (response?.success && response?.data?.promotors) {
                const promoterData = response.data.promotors;
                this.setState({ 
                    promoters: promoterData, 
                    rows: promoterData, 
                    loading: false,
                    cached: response.cached,
                    dateRange: response.data.dateRange
                });

                // Log performance info
                if (response.data.computeTime) {
                    console.log(`📊 Promotors loaded in ${response.data.computeTime}ms (cached: ${response.cached})`);
                }
            } else {
                // Fallback to empty state
                this.setState({ promoters: [], rows: [], loading: false });
            }
        } catch (error) {
            console.error('Error fetching promotors:', error);
            message.error(`Error al cargar ${t('promotoresLower')}`);
            this.setState({ promoters: [], rows: [], loading: false });
        }
    }

    /**
     * Force refresh the promotors data (bypasses cache)
     */
    async refreshPromotors() {
        message.loading('Actualizando datos...', 0.5);
        await this.fetchPromotorsOptimized(true);
        message.success('Datos actualizados');
    }

    async removePromoter(id) {
        const user = await this.data.updateUser(id, { active: false });
        if (user) {
            message.success(`${t('promotor')} eliminado correctamente`);
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } else {
            message.error(`Error al eliminar ${t('promotorLower')}`);
        }
    }

    /** Client users are scoped to their own client: no analytics, no client filter, no deletes. */
    isClientUser() {
        return User.getInstance()?.userType === 'client';
    }

    navigateToAnalytics() {
        this.props.navigate('/dashboard/trade/promoters/analytics');
    }
}

export default PromotorsController;
